export enum CmmStatus {
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  FAILED = "failed",
  INITIATED = "initiated",
  INVALID_KEY = "invalid_key",
  DUPLICATE_KEY = "duplicate_key",
  PATIENT_MISMATCH = "patient_mismatch",
  ADDITIONAL_QA = "additional_qa",
  STP_FAILED = "stp_failed",
  EXPIRED = "expired",
  NEEDS_API = "needs_api",
  NOT_STARTED = "not_started",
  PENDING = "pending",
}
